(function () {
  const grids = document.querySelectorAll('.troy-portfolio__grid');
  if (!grids.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const mobileMq = window.matchMedia('(max-width: 749px)');

  grids.forEach((grid) => {
    let triggered = false;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || triggered || !mobileMq.matches) return;
          triggered = true;
          observer.unobserve(grid);
          window.setTimeout(() => bounce(grid), 280);
        });
      },
      { threshold: 0.35 }
    );

    observer.observe(grid);
  });

  function bounce(grid) {
    const distance = 56;
    const sequence = [
      [distance, 320],
      [0, 320],
      [distance, 320],
      [0, 360],
    ];

    grid.classList.add('is-bouncing');

    let i = 0;
    function step() {
      if (i >= sequence.length) {
        grid.classList.remove('is-bouncing');
        return;
      }
      const [pos, dur] = sequence[i++];
      grid.scrollTo({ left: pos, behavior: 'smooth' });
      window.setTimeout(step, dur);
    }
    step();
  }
})();
